/**
 * atomberg-image-carousel.js
 * ───────────────────────────
 * Wires mouse drag-to-scroll onto every Image Carousel track via the shared
 * AtombergDragScroll utility (touch scrolls natively). Arrow navigation and
 * the optional infinite wrap live in atomberg-carousel-arrows.js.
 * Requires atomberg-drag-scroll.js to load first.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergImageCarouselInit) return;
  w._atombergImageCarouselInit = true;

  function wire() {
    if (!w.AtombergDragScroll) return;
    document.querySelectorAll('.atomberg-image-carousel__track').forEach(function (el) {
      var track = /** @type {any} */ (el);
      if (track._atombergDragWired) return;
      track._atombergDragWired = true;
      w.AtombergDragScroll.enable(/** @type {HTMLElement} */ (el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  // Theme editor re-renders sections in place; re-scan for fresh tracks
  document.addEventListener('shopify:section:load', wire);
})();
